import React from "react";
import ProgressBar from "../ui-elements/ProgressBar/ProgressBar";
import Age from "../components/Age/Age";

import "./NutiCal.scss";
import "../style/style.scss";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Gender from "../components/Gender/Gender";
import { Nutrical } from "../models/Neutrical";
import UserType, { UserTypeE } from "../components/UserType/UserType";
import Weight from "../components/Weight/Weight";
import Goal from "../components/Goal/Goal";
import GoalTarget from "../components/Goal-Target/Goal-Target";
import EatingStyle from "../components/EatingStyle/EatingStyle";
import Meal from "../components/Meal/Meal";
import Activity from "../components/Activity/Activity";
import Workout from "../components/Workout/Workout";
import MacroNutrient, { GraphMode } from "../components/MacroNutrient/MacroNutrients";
import Result from "../components/Result/Result";
import HeightView from "../components/Height/Height";
import MacroNutrientCustom from "../components/MacroNutrientsCustom/MacroNutrientsCustom";
import { IconButton } from "@mui/material";
import Logo from '../assets/Logo.png';

const NutriCalPage: React.FC = (): JSX.Element => {
	const [nutrical, setNutrical] = React.useState(new Nutrical());
	const [title, setTitle] = React.useState("");
	const [subTitle, setSubTitle] = React.useState("");
	const [questionNumber, setQuestionNumber] = React.useState(1);
	const [progressPercentage, setProgressPercent] = React.useState(20);

	const jumpToResults = () => {
		nutrical.userType = UserTypeE.MySelf;
		nutrical.createMock();
		setQuestionNumber(13);
		const question = nutrical.getQuestion(13);
		setTitle(question.title);
		setSubTitle(question.subTitle);
	}
	const goBack = (): void => {
		let newQuestionNumber = questionNumber - 1
		if ((questionNumber === 10 && nutrical.goal.macroNutrient!.graphMode === GraphMode.standard) || questionNumber === 7) {
			newQuestionNumber = questionNumber - 2;
		}
		changeQuestion(newQuestionNumber);
		setProgress(newQuestionNumber);

	};

	const valueSelected = (response?: any): void => {
		if (handleResponse(response)) {
			changeQuestion(questionNumber + 1);
			setProgress(questionNumber + 1);
		}
	};

	const changeQuestion = (questionIndex: number) => {
		let newQuestionNumber = questionIndex;
		if (newQuestionNumber > nutrical.numberOfQuestions) {
			return;
		} else if (newQuestionNumber < 0) {
			return;
		} else {
			setQuestionNumber(newQuestionNumber);
		}
		const question = nutrical.getQuestion(newQuestionNumber);
		setTitle(question.title);
		setSubTitle(question.subTitle);
	};

	const setProgress = (questionNumber: number): void => {
		switch (questionNumber) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:

				setProgressPercent(20);
				break;
			case 5:
			case 6:
				setProgressPercent(40);
				break;
			case 7:
			case 8:
			case 9:
				setProgressPercent(60);
				break;
			case 10:
			case 11:
			case 12:
				setProgressPercent(80);
				break;

			case 13:
				setProgressPercent(100);
				break;
		}
	}
	const handleResponse = (response?: any): boolean => {
		if (typeof response === "undefined" && questionNumber === 0) {
			return true;
		}
		switch (questionNumber) {
			case 0:
				{
					nutrical.userType = response;
					setNutrical(nutrical);
				}
				return true;
			case 5: {
				changeQuestion(questionNumber + 2);
				setProgress(questionNumber + 2);
				return false;
			}
			case 8:
				if (response !== "custom") {
					changeQuestion(questionNumber + 2);
					return false;
				} else {
					return true;
				}
			case 12:
				nutrical.calculateNutrition();
				return true;
			default:
				return true;
		}
	};

	const renderQuestions = () => {
		switch (questionNumber) {
			case 0:
				return <UserType userType={""} valueSelected={valueSelected}></UserType>;
			case 1:
				return <Age detail={nutrical.detail} valueSelected={valueSelected}></Age>;
			case 2:
				return <Gender detail={nutrical.detail} valueSelected={valueSelected}></Gender>;
			case 3:
				return <HeightView detail={nutrical.detail} valueSelected={valueSelected}></HeightView>;
			case 4:
				return <Weight detail={nutrical.detail} valueSelected={valueSelected}></Weight>;
			case 5:
				return <Goal nutrical={nutrical} valueSelected={valueSelected}></Goal>;
			case 6:
				return <GoalTarget goal={nutrical.goal} valueSelected={valueSelected}></GoalTarget>;
			case 7:
				return <EatingStyle goal={nutrical.goal} valueSelected={valueSelected}></EatingStyle>;
			case 8:
				return <MacroNutrient goal={nutrical.goal} valueSelected={valueSelected}></MacroNutrient>;
			case 9:
				return <MacroNutrientCustom goal={nutrical.goal} valueSelected={valueSelected}></MacroNutrientCustom>;
			case 10:
				return <Meal goal={nutrical.goal} valueSelected={valueSelected}></Meal>;
			case 11:
				return <Activity goal={nutrical.goal} valueSelected={valueSelected}></Activity>;
			case 12:
				return <Workout goal={nutrical.goal} valueSelected={valueSelected}></Workout>;
			case 13:
				return <Result nutrical={nutrical}></Result>;

			// default:
			// 	return <Age age={0} valueSelected={valueSelected}></Age>;
		}
	};

	React.useEffect(() => {
		const question = nutrical.getQuestion(questionNumber);
		setTitle(question.title);
		setSubTitle(question.subTitle);
		//UserApi.writeUserData("Jithendra Thenuwara","jithendrathenu@gmail.com", "777115729");
	}, []);

	return (
		<>
			<div style={{display:'flex', justifyContent:'center', width:'100%'}}>
				<div className="header-container">
					<IconButton onClick={goBack}>
						<ArrowBackIcon fontSize='large'/>
					</IconButton>
					<img className="logo" src={Logo} alt="Saara Life Logo"/>
					<button onClick={jumpToResults} style={{visibility: "hidden"}}>Jump</button>


				</div>
			</div>
			<div className="detail-container">
				<ProgressBar progressPercentage={progressPercentage}></ProgressBar>
			</div>
			<div className="subtitle">{subTitle}</div>
			<h2 className="title">{title}</h2>

			{/* <Age age={0}></Age> */}
			{/* <Gender gender={''}></Gender> */}
			{renderQuestions()}
		</>
	);
};

export default NutriCalPage;
